/**
 * 2019-04-16
 * handan
 * loading的状态管理
 */
const defaultValue = {
  isShowLoading: false,
}

export default ( state=defaultValue, action )=>{
  switch (action.type) {
    case "setLoadingState":
      return {
        ...state,
        isShowLoading: action.data
      }
      break;
  
    default:return state
      break;
  }
}